import createIcon from '../../createIcon';

/**
 * @component @name ClosedCaption
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgNEg1QzMuODkgNCAzIDQuOSAzIDZWMThDMyAxOS4xIDMuODkgMjAgNSAyMEgxOUMyMC4xIDIwIDIxIDE5LjEgMjEgMThWNkMyMSA0LjkgMjAuMSA0IDE5IDRaTTExIDExSDkuNVYxMC41SDcuNVYxMy41SDkuNVYxM0gxMVYxNEMxMSAxNC41NSAxMC41NSAxNSAxMCAxNUg3QzYuNDUgMTUgNiAxNC41NSA2IDE0VjEwQzYgOS40NSA2LjQ1IDkgNyA5SDEwQzEwLjU1IDkgMTEgOS40NSAxMSAxMFYxMVpNMTggMTFIMTYuNVYxMC41SDE0LjVWMTMuNUgxNi41VjEzSDE4VjE0QzE4IDE0LjU1IDE3LjU1IDE1IDE3IDE1SDE0QzEzLjQ1IDE1IDEzIDE0LjU1IDEzIDE0VjEwQzEzIDkuNDUgMTMuNDUgOSAxNCA5SDE3QzE3LjU1IDkgMTggOS40NSAxOCAxMFYxMVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ClosedCaption = createIcon('ClosedCaption', [
  [
    'path',
    {
      d: 'M19 4H5C3.89 4 3 4.9 3 6V18C3 19.1 3.89 20 5 20H19C20.1 20 21 19.1 21 18V6C21 4.9 20.1 4 19 4ZM11 11H9.5V10.5H7.5V13.5H9.5V13H11V14C11 14.55 10.55 15 10 15H7C6.45 15 6 14.55 6 14V10C6 9.45 6.45 9 7 9H10C10.55 9 11 9.45 11 10V11ZM18 11H16.5V10.5H14.5V13.5H16.5V13H18V14C18 14.55 17.55 15 17 15H14C13.45 15 13 14.55 13 14V10C13 9.45 13.45 9 14 9H17C17.55 9 18 9.45 18 10V11Z',
      key: '1ih0rm',
    },
  ],
]);

export default ClosedCaption;
